export const GLOBAL_STATE = 'PreFoundationApplication'

export const PFC_APPLICATION_CREATE = 'PFC_APPLICATION_CREATE'
export const PFC_APPLICATION_LIST = 'PFC_APPLICATION_LIST'
export const PFC_APPLICATION_EDIT = 'PFC_APPLICATION_EDIT'
export const PFC_APPLICATION_RESET_PASSWORD = 'PFC_APPLICATION_RESET_PASSWORD'
export const PFC_APPLICATION_STATUS = 'PFC_APPLICATION_STATUS'
export const PFC_APPLICATION_UPDATE = 'PFC_APPLICATION_UPDATE'

export const PFC_APPLICATION_FORM_ALL = 'PFC_APPLICATION_FORM_ALL'
export const PFC_APPLICATION_FORM_CURRENT = 'PFC_APPLICATION_FORM_CURRENT'
export const PFC_APPLICATION_FORM_FIELD_BATCH = 'PFC_APPLICATION_FORM_FIELD_BATCH'
export const PFC_APPLICATION_FORM_FIELD_BATCH_CREATE = 'PFC_APPLICATION_FORM_FIELD_BATCH_CREATE'

export const PFC_PAYMENT_LIST = 'PFC_PAYMENT_LIST'
export const PFC_PAYMENT_CREATE = 'PFC_PAYMENT_CREATE'
export const PFC_PAYMENT_ALL = 'PFC_PAYMENT_ALL'
export const PFC_PAYMENT_PRINCIPAL = 'PFC_PAYMENT_PRINCIPAL'
export const PFC_PAYMENT_CONFIRM = 'PFC_PAYMENT_CONFIRM'
